import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGameList = {
  gameList: { data: null, loading: false, error: null },
};

export const gameList = createAsyncThunk('user/gameList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/game/list`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGameList = {
  [gameList.pending]: (state) => {
    state.gameList.loading = true;
  },
  [gameList.fulfilled]: (state, action) => {
    state.gameList.loading = false;
    state.gameList.data = action.payload;
    state.gameList.error = null;
  },
  [gameList.rejected]: (state, action) => {
    state.gameList.loading = false;
    state.gameList.error = action.payload;
  },
};
